import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


$(document).ready(function(){


  if (document.querySelector('.dual-image--layout1')) {
    var gemeinsamWachsen = gsap.timeline();

    gemeinsamWachsen
    .from(".dual-image--layout1 > .dual-image__first", {duration: 1, x: -100, opacity: 0})
    .from(".dual-image--layout1 > .dual-image__second", {duration: 1, x: 100, opacity: 0},"-=.5");

  };


  if (document.querySelector('.scroll')) {

   let dualImageContainers = gsap.utils.toArray('.scroll')

  ScrollTrigger.matchMedia({
    "(min-width: 800px)": function() {

    dualImageContainers.forEach((container) => {
      let scrollBottom = gsap.utils.toArray('.dual-image__first, .scrollToBottom')
      let scrollTop = gsap.utils.toArray('.dual-image__second, .scrollToTop')

      gsap.to(scrollBottom, {
        yPercent: 40,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: "-50%",
          // end: "100%",
          scrub: true
        }, 
      });

      gsap.to(scrollTop, {
        yPercent: -40,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: "-50%",
          // end: "center top",
          scrub: true
        }, 
      });

    })

  }})

};


});